import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const PrimarySchool = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
        AOS.init({ duration: 1000 });
    }, []);

    return (
        <div className="container mx-auto px-6 py-12">
            {/* Heading */}
            <p className="md:text-3xl text-2xl font-bold text-center mb-6">
  SVN CONVENT PRIMARY SCHOOL
</p>
<h2 className="md:text-2xl text-xl font-bold text-center mb-6">
  1st to 7th Standard
</h2>


            {/* Description */} 
            <div className="flex flex-col md:flex-row items-center justify-center  md:text-left my-12" data-aos="fade-up">
                {/* Image Section */}
                <div className="md:w-1/2 flex justify-center">
                    <img 
                        src="https://img.freepik.com/free-vector/back-school-with-happiness_18591-52320.jpg?ga=GA1.1.736731524.1738591350&semt=ais_hybrid" 
                        alt="Primary Learning" 
                        className="w-full md:w-4/5 h-64 rounded-lg shadow-md"
                    />
                </div>

                {/* Text Section */}
                <div className="md:w-1/2 flex items-center justify-center">
                    <p className="text-lg md:mt-0 mt-10 text-gray-700 leading-relaxed">
                        Our Primary School offers a balanced curriculum focusing on academic excellence, 
                        co-curricular activities, and character building. Students from 1st to 7th standard 
                        receive quality education in a nurturing environment that promotes creativity, 
                        curiosity, and critical thinking.
                    </p>
                </div>
            </div>

            {/* Teaching Methodology */}
            <div className="flex flex-col md:flex-row items-center my-12 md:items-start" data-aos="fade-up">
                <div className="md:w-1/2 text-left">
                    <h2 className="text-2xl font-semibold mb-4">Innovative Learning Approach</h2>
                    <p className="text-lg text-gray-700 leading-relaxed mb-6">
                        We incorporate modern teaching techniques such as interactive digital learning, 
                        project-based assignments, and hands-on experiments to enhance student engagement and understanding.
                    </p>
                    <h2 className="text-2xl font-semibold mb-4">Holistic Development</h2>
                    <p className="text-lg text-gray-700 leading-relaxed">
                        Students are encouraged to participate in sports, arts, and extracurricular activities 
                        to foster well-rounded development.
                    </p>
                </div>

                {/* Right Image */}
                <div className="md:w-1/2 flex justify-center mt-6 md:mt-0">
                    <img 
                        src="https://img.freepik.com/free-vector/kids-education-concept_52683-93184.jpg" 
                        alt="Holistic Learning" 
                        className="w-full md:w-4/5 rounded-lg shadow-md"
                    />
                </div>
            </div>

            {/* Facilities Section */}
            <h2 className="text-2xl font-bold text-center mt-12 mb-6">Facilities for Primary Students</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 mb-6 gap-6" data-aos="fade-up">
                <div className="bg-white shadow-md rounded-lg p-6 text-center">
                    <img src="https://img.freepik.com/premium-vector/happy-children-come-home-from-school_50699-579.jpg?ga=GA1.1.736731524.1738591350&semt=ais_hybrid" alt="Smart Classrooms" className="w-full h-40 object-cover rounded-md mb-4"/>
                    <h3 className="text-xl font-semibold">Smart Classrooms</h3>
                    <p className="text-gray-600 mt-2">Equipped with digital boards and audio-visual aids to enhance learning.</p>
                </div>
                <div className="bg-white shadow-md rounded-lg p-6 text-center">
                    <img src="https://img.freepik.com/premium-vector/happy-children-come-home-from-school_50699-579.jpg?ga=GA1.1.736731524.1738591350&semt=ais_hybrid" alt="Sports Facilities" className="w-full h-40 object-cover rounded-md mb-4"/>
                    <h3 className="text-xl font-semibold">Sports & Activities</h3>
                    <p className="text-gray-600 mt-2">A wide range of sports, music, and arts activities for overall development.</p>
                </div>
                <div className="bg-white shadow-md rounded-lg p-6 text-center">
                    <img src="https://img.freepik.com/premium-vector/happy-children-come-home-from-school_50699-579.jpg?ga=GA1.1.736731524.1738591350&semt=ais_hybrid" alt="Library" className="w-full h-40 object-cover rounded-md mb-4"/>
                    <h3 className="text-xl font-semibold">Well-stocked Library</h3>
                    <p className="text-gray-600 mt-2">A vast collection of books to encourage reading habits among students.</p>
                </div>
            </div>

            {/* Gallery */}
            <h2 className="text-2xl font-bold text-center mt-12 mb-6">Gallery</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 mt-8" data-aos="fade-up">
                <img src="https://img.freepik.com/free-vector/kids-learning-science_1308-87946.jpg" alt="Science Learning" className="w-full h-48 object-cover rounded-lg shadow-md" />
                <img src="https://img.freepik.com/free-vector/kids-art-class_1308-87965.jpg" alt="Art Class" className="w-full h-48 object-cover rounded-lg shadow-md" />
                <img src="https://img.freepik.com/free-vector/kids-reading-books_1308-94758.jpg" alt="Library Reading" className="w-full h-48 object-cover rounded-lg shadow-md" />
                <img src="https://img.freepik.com/free-vector/kids-playing-school-playground_1308-89379.jpg" alt="Playground Fun" className="w-full h-48 object-cover rounded-lg shadow-md" />
            </div>
        </div>
    );
}

export default PrimarySchool;
